export const getCdnUrl = (iataCode: string, path?: string) =>
	path ? `https://cdn.websky.aero/content/frontend/images/${iataCode}/${path}` : '';

export const getContentUrl = (iataCode: string, path?: string) =>
	path ? `https://cdn.websky.aero/content/${iataCode}/images/${path}` : '';

export const isSvgUrl = (url: string): boolean => {
	try {
		const { pathname } = new URL(url, window.location.href);

		return pathname.toLowerCase().endsWith('.svg');
	} catch {
		return url.toLowerCase().endsWith('.svg');
	}
};
